import React from 'react';
import styled from 'styled-components';
import { getSize } from '../../hooks';
import { jsx as _jsx } from "react/jsx-runtime";

var defaultContentPadding = function defaultContentPadding(p) {
  return "".concat(getSize('padding8')(p), " ").concat(getSize('padding12')(p), " 0 ").concat(getSize('padding12')(p));
};

var StyledContent = styled.main.withConfig({
  displayName: "layoutContent__StyledContent",
  componentId: "sc-6xaaca-0"
})(["flex:1 1 auto;display:flex;flex-direction:column;overflow:hidden;position:relative;"]);
var ContentInner = styled.div.withConfig({
  displayName: "layoutContent__ContentInner",
  componentId: "sc-6xaaca-1"
})(["flex:1;min-height:0;display:flex;flex-direction:column;overflow:hidden;padding:", ";"], function (p) {
  return p.$padding != null ? p.$padding : defaultContentPadding(p);
});

var resolvePaddingProp = function resolvePaddingProp(padding) {
  if (padding === undefined) return undefined;
  if (typeof padding === 'number') return "".concat(padding, "px");
  return padding;
};

export var LayoutContent = function LayoutContent(_ref) {
  var children = _ref.children,
      padding = _ref.padding;
  return /*#__PURE__*/_jsx(StyledContent, {
    children: /*#__PURE__*/_jsx(ContentInner, {
      $padding: resolvePaddingProp(padding),
      children: children
    })
  });
};
LayoutContent.displayName = 'LayoutContent';